import { authService } from '../../service/auth-service'
import { AxiosInstance } from 'axios'

export const logoutOnErrorInterceptor = (axiosInstance: AxiosInstance): void => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        await authService.logout()
      }
      return Promise.reject(error)
    },
  )
}
